import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

export default function StubPage({
  eyebrow,
  title,
  description,
  testId = "stub-page",
}) {
  return (
    <div data-testid={testId} className="relative">
      <Navbar />
      <section className="relative pt-44 pb-32">
        <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[60rem] h-[60rem] radial-glow opacity-50 pointer-events-none" />
        <div className="relative max-w-3xl mx-auto px-6 md:px-12 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-300 text-xs font-semibold tracking-widest uppercase">
            {eyebrow}
          </div>
          <h1 className="mt-6 font-display text-5xl md:text-6xl font-extrabold tracking-tight leading-[1.05]">
            {title}
          </h1>
          <p className="mt-6 text-lg text-white/60">{description}</p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              data-testid="stub-back-home"
              className="inline-flex items-center justify-center gap-2 bg-white/5 border border-white/10 text-white font-semibold px-6 py-3 rounded-full hover:bg-white/10 transition-all"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Link>
            <Link
              to="/#audit"
              data-testid="stub-book-audit"
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-cyan-400 text-black font-semibold px-6 py-3 rounded-full hover:shadow-[0_0_30px_rgba(0,229,255,0.45)] transition-all"
            >
              Book Free Audit
            </Link>
          </div>

          <div className="mt-16 rounded-3xl border border-white/10 bg-white/[0.025] p-10">
            <p className="text-white/55">
              This page is in active development. Detailed{" "}
              <span className="text-cyan-300">{eyebrow.toLowerCase()}</span>{" "}
              content will live here soon. In the meantime, explore the home
              page or get in touch.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
